import { SizeProp } from "@fortawesome/fontawesome-svg-core";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function Spinner({ size }: { size?: SizeProp }) {
  return (
    <FontAwesomeIcon
      spinPulse
      className="animate-spin"
      icon={faSpinner}
      size={size}
    />
  );
}
